import styled from 'styled-components';
import { InfoTitle } from '../../../../Toolkit/InfoTitle/InfoTitle';
import { media } from '../../../../../helpers/breakpoints';
import { SellerRatingsSummary as BaseSellerRatingsSummary } from '../SellerRatingsSummary/SellerRatingsSummary';
import { Link } from '../../../../Toolkit/Button/Link';
import { LinkButton } from '../../../../Toolkit/Button/LinkButton';

const ActionsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S8};
`;

const DealerRatings = styled.div`
  margin-bottom: 0;
`;

const DealerReviewInfoTitle = styled(InfoTitle)`
  ${media.large} {
    min-height: unset;
    margin-bottom: ${({ theme }) => theme.spacing.S8};
    margin-top: ${({ theme }) => theme.spacing.S8};
  }
`;

const SellerRatingsSummary = styled(BaseSellerRatingsSummary)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const MiniUserProfileAndVerifiedListContainer = styled.div<{
  googleReviews?: boolean;
}>`
  margin-bottom: ${({ theme, googleReviews }) =>
    googleReviews ? `0` : theme.spacing.M16};
`;

const VisitAdsLink = styled(Link)`
  text-align: center;
`;

const TrustedDealerTypeButton = styled(LinkButton)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S4};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  // Remove underline on hover/focus for LinkButton this button has a custom dashed underline that is always visible
  &:hover,
  &:focus-visible {
    text-decoration: none;
  }
`;

const TrustedTypeText = styled.span`
  ${({ theme }) => theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  border-bottom: 1px dashed ${({ theme }) => theme.colors.GREY};
`;

const Subtitle = styled.div`
  ${({ theme }) => theme.fontSize.B12};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  white-space: nowrap;
`;

export {
  MiniUserProfileAndVerifiedListContainer,
  ActionsList,
  DealerRatings,
  DealerReviewInfoTitle,
  SellerRatingsSummary,
  VisitAdsLink,
  TrustedDealerTypeButton,
  TrustedTypeText,
  Subtitle,
};
